import { NEWSBOARD_REQUEST_STATUS_CHANGED_TYPE } from '../../../Newsboard.constants'

export const HIDE_MESSAGE_POST_TYPES = [NEWSBOARD_REQUEST_STATUS_CHANGED_TYPE]

export const QA_NAME_TAG_ITEM = 'audience'
